import React from 'react'
import { reduxForm } from 'redux-form'
import Dropdown from 'components/dropdown'
import PropTypes from 'prop-types'
import Footer from 'multi-vertical/rate-table/components/filter-modal/footer'
import styles from './styles.module.scss'

const categories = [
    {
      value: 'featured',
      label: 'Featured cards',
    },
    {
      value: 'rewards',
      label: 'Rewards cards',
    },
    {
      value: 'balance-transfer',
      label: 'Balance transfer cards',
    },
    {
      value: 'zero-percent',
      label: 'Zero percent cards',
    },
    {
      value: 'secured',
      label: 'Secured cards',
    },
    {
      value: 'student',
      label: 'Student cards',
    },
    {
      value: 'low-interest',
      label: 'Low interest cards',
    },
  ],

  CreditCardsFilterForm = ({ closeModal, update, reset, invalid, withFooter, onChangeCategory }) => {
    const cancel = () => {
      closeModal()
      // Setting timeout so the form doesn't reset as the modal is disappearing
      setTimeout(() => { reset() }, 500)
    }

    return (
      <>
        <div className={styles.filters}>
          <Dropdown
            onChange={onChangeCategory}
            icon={false}
            name="categoryFilter"
            options={categories}
            placeholder="Filter by card type"
            label="Filter by card type"
          />
        </div>
        {withFooter && <Footer cancel={cancel} invalid={invalid} update={update} />}
      </>
    )
  },

  noop = () => { }

CreditCardsFilterForm.propTypes = {
  closeModal: PropTypes.func,
  update: PropTypes.func,
  reset: PropTypes.func,
  invalid: PropTypes.bool,
  withFooter: PropTypes.bool,
  onChangeCategory: PropTypes.func,
}

CreditCardsFilterForm.defaultProps = {
  closeModal: noop,
  update: noop,
  reset: noop,
  onChangeCategory: noop,
  withFooter: false,
}

export { CreditCardsFilterForm as CreditCardsFilterFormNoHoc }

export default reduxForm({
  keepDirtyOnReinitialize: false,
  enableReinitialize: true,
})(CreditCardsFilterForm)
